<template>
  <div class="privacy-settings">
    <div class="animated fadeIn">
      <div v-if="loading">
        <b-col md="6">
          <atom-spinner
            :animation-duration="1000"
            :size="60"
            color="#ff1d5e"
            class="float-right my-4"
          />
        </b-col>
      </div>
      <div v-else class="animated fadeIn">
        <component-header
          title="Privacy Setting"
          @search-query="(val) => (filter = val)"
          @create-press="createPrivacySetting"
          :isLoading="loading"
          :hasReload="true"
          @reload-data="fetchData"
        />
        <b-card class="card-wrap" border-variant="info">
          <b-row class="justify-content-center">
            <b-col>
              <b-table
                class="text-center tableRadius"
                :items="tableData"
                :fields="fields"
                :bordered="bordered"
                responsive
                :filter="filter"
                thead-class="header"
                :busy="loading"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template #status="data">
                  <div
                    class="toggle-container"
                    :class="{ 'toggle-on': data.item.isOn }"
                    @click="toggle(data.item)"
                  >
                    <div class="toggle-button"></div>
                  </div>
                </template>
                <template #createdAt="data">
                  {{ formatDate(data.item.createdAt) }}
                </template>
                <template #updatedAt="data">
                  {{ formatDate(data.item.updatedAt) }}
                </template>
                <template #action="data">
                  <div class="inline_btnTable">
                    <b-button
                      size="sm"
                      class="button-circle mr-2"
                      style="background: #fe7b08; border: #fe7b08"
                      variant="primary"
                      @click="editItem(data.item)"
                    >
                      <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button
                      size="sm"
                      class="button-circle"
                      @click="deleteItem(data.item)"
                      variant="danger"
                    >
                      <i class="fa fa-trash"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader";
import loader from "@/components/loader/nipigeloader.vue";
import Swal from "sweetalert2";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    ComponentHeader,
    AtomSpinner,
    loader,
  },
  data() {
    return {
      loading: true,
      filter: "",
      sortBy: "",
      sortDesc: true,
      striped: true,
      bordered: true,
      tableData: [],
      fields: [
        { key: "title", label: "Title" },
        { key: "content", label: "Type" },
        { key: "slug", label: "Scope" },
        { key: "createdAt", label: "Created On" },
        { key: "updatedAt", label: "Updated On" },
        { key: "status", label: "Status" },
        { key: "action", label: "Action" },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    createPrivacySetting() {
      this.$router.push({ name: "Create Privacy Setting" });
    },
    toggle(item) {
      item.isOn = !item.isOn;
    },
    async fetchData() {
      this.loading = true;
      try {
        const currentUserId = this.$currentUserData._id;
        const response = await this.$store.dispatch(
          "privacySetting/listPrivacySettingAction",
          currentUserId
        );
        this.tableData = response.data.map((item) => ({
          ...item,
          isOn: item.isOn || false,
        }));
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY hh:mm A");
    },
    async deleteItem(item) {
      const deleteId = item._id;
      await Swal.fire({
        title: "Are you sure?",
        text: "You can't revert this action!!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("privacySetting/deletePrivacySettingAction", deleteId)
            .then(() => {
              this.$toasted.success("Privacy Deleted Successfully");
              this.fetchData();
            })
            .catch(() => {
              // delete failed
            });
        }
      });
    },
    editItem(item) {
      this.$router.push({
        name: "Edit Privacy Setting",
        params: { data: item },
      });
    },
  },
};
</script>

<style>
.privacy-settings {
  background-color: #f9f9f9;
  min-height: 100vh;
}
.tableRadius {
  border-radius: 12px;
  background-color: #fff;
}

.toggle-container {
  display: inline-block;
  width: 50px;
  height: 25px;
  background-color: #ccc;
  border-radius: 15px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.3s;
}

.toggle-container.toggle-on {
  background-color: #4caf50;
}

.toggle-button {
  width: 23px;
  height: 23px;
  background-color: white;
  border-radius: 50%;
  position: absolute;
  top: 1px;
  left: 1px;
  transition: left 0.3s;
}

.toggle-container.toggle-on .toggle-button {
  left: 26px;
}

/* Mobile specific styles */
@media (max-width: 767px) {
  .privacy-settings {
    padding: 10px;
  }

  .tableRadius {
    border-radius: 8px;
  }

  /* Modify table styles for mobile view */
  .tableRadius .b-table-stacked {
    display: block;
    width: 100%;
  }

  .toggle-container {
    width: 40px;
    height: 20px;
  }

  .toggle-button {
    width: 18px;
    height: 18px;
  }

  .toggle-container.toggle-on .toggle-button {
    left: 20px;
  }
}
</style>
